import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../pictures/sdl22.png";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../store/adminSlice";

function Sidebar({ setSidebarOpen, isNonMobile, needed }) {
  const navigate = useNavigate();
  const stateAlert = useSelector((state) => state.admin.alert);
  const adminID = useSelector((state) => state.admin._id);
  const statesignOut = useSelector((state) => state.admin.signOut);
  const isOfficeAdmin = useSelector((state) => state.admin.isOfficeAdmin);
  const dispatch = useDispatch();

  useEffect(() => {
    if (adminID === "") {
      navigate("/signin");
    }
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [adminID, statesignOut]);

  const signOut = () => {
    const adminData = localStorage.removeItem("adminData");
    dispatch(adminActions.signOut());
  };

  const priceList = () => {
    if (!isNonMobile) {
      navigate("/pricelist");
      setSidebarOpen(false);
    } else {
      navigate("/pricelist");
    }
  };

  const scaffoldingInspection = () => {
    if (!isNonMobile) {
      navigate("/scaffoldinginspections");
      setSidebarOpen(false);
    } else {
      navigate("/scaffoldinginspections");
    }
  };

  const keyStaff = () => {
    if (!isNonMobile) {
      navigate("/staffmember");
      setSidebarOpen(false);
    } else {
      navigate("/staffmember");
    }
  };

  const addNewJob = () => {
    if (!isNonMobile) {
      navigate("/addanewjob");
      setSidebarOpen(false);
    } else {
      navigate("/addanewjob");
    }
  };
  const addAdaption = () => {
    if (!isNonMobile) {
      navigate("/addadaption");
      setSidebarOpen(false);
    } else {
      navigate("/addAdaption");
    }
  };
  const AddANewVechile = () => {
    if (!isNonMobile) {
      navigate("/addanewvechile");
      setSidebarOpen(false);
    } else {
      navigate("/addanewvechile");
    }
  };
  const archiveQoute = () => {
    if (!isNonMobile) {
      navigate("/archivependingprojectquotes");
      setSidebarOpen(false);
    } else {
      navigate("/archivependingprojectquotes");
    }
  };

  const createNewCustomer = () => {
    if (!isNonMobile) {
      navigate("/createnewcustomer");
      setSidebarOpen(false);
    } else {
      navigate("/createnewcustomer");
    }
  };

  const adminUpload = () => {
    if (!isNonMobile) {
      navigate("/adminupload");
      setSidebarOpen(false);
    } else {
      navigate("/adminupload");
    }
  };
  const vechicleCheck = () => {
    if (!isNonMobile) {
      navigate("/vechiclecheck");
      setSidebarOpen(false);
    } else {
      navigate("/vechiclecheck");
    }
  };
  const vechicleInspection = () => {
    if (!isNonMobile) {
      navigate("/vechicleinspection");
      setSidebarOpen(false);
    } else {
      navigate("/vechicleinspection");
    }
  };
  const dismantle = () => {
    if (!isNonMobile) {
      navigate("/dismantle");
      setSidebarOpen(false);
    } else {
      navigate("/dismantle");
    }
  };
  const handOver = () => {
    if (!isNonMobile) {
      navigate("/viewhandover");
      setSidebarOpen(false);
    } else {
      navigate("/viewhandover");
    }
  };
  const jobList = () => {
    if (!isNonMobile) {
      navigate("/joblist");
      setSidebarOpen(false);
    } else {
      navigate("/joblist");
    }
  };
  const printallinspections = () => {
    if (!isNonMobile) {
      navigate("/scaffoldinspectionlist");
      setSidebarOpen(false);
    } else {
      navigate("/scaffoldinspectionlist");
    }
  };
  const scaffoldingInspections = () => {
    if (!isNonMobile) {
      navigate("/allscaffoldingInspections");
      setSidebarOpen(false);
    } else {
      navigate("/allscaffoldingInspections");
    }
  };
  const signOutt = () => {
    dispatch(signOut());
  };
  const healthAndsafety = () => {
    if (!isNonMobile) {
      navigate("/healthandsafety");
      setSidebarOpen(false);
    } else {
      navigate("/healthandsafety");
    }
  };

  return (
    <div className="w-full h-full flex flex-col overflow-y-auto overflow-x-hidden bg-white shadow-lg">
      {/* Mobil kapatma butonu */}
      <div
        className={`w-full flex justify-end pt-2 px-2 ${
          isNonMobile ? "hidden" : "block"
        }`}
      >
        <IconButton onClick={() => setSidebarOpen(false)}>
          <ArrowBackIosIcon style={{ color: "#66c18a" }} />
        </IconButton>
      </div>

      {/* Menü Öğeleri */}
      <div className="flex flex-col justify-start w-full p-2 space-y-1 overflow-y-auto">
        {!isOfficeAdmin && (
          <>
            <div className="border-b border-gray-200 pb-2 mb-2">
              <h3 className="px-2 text-sm font-semibold text-gray-1000">
                Company Settings
              </h3>
            </div>

            <div
              className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
              onClick={adminUpload}
            >
              Set up your company
            </div>
            <div
              className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
              onClick={keyStaff}
            >
              Add key staff
            </div>
            <div
              className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
              onClick={priceList}
            >
              Set up your Price List
            </div>
            <div
              className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
              onClick={() => {
                if (!isNonMobile) {
                  navigate("/manageofficeadmins");
                  setSidebarOpen(false);
                } else {
                  navigate("/manageofficeadmins");
                }
              }}
            >
              Manage Office Admins
            </div>
          </>
        )}

        <div className="border-b border-gray-200 pb-1 mt-4 mb-2">
          <h3 className="px-2 text-sm font-semibold text-gray-1000">
            Customer Management
          </h3>
        </div>

        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={createNewCustomer}
        >
          Create a customer
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={addNewJob}
        >
          Add a new job
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={healthAndsafety}
        >
          Upload health & safety
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={addAdaption}
        >
          Add adaptions
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={dismantle}
        >
          Dismantles
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={handOver}
        >
          Handovers
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={jobList}
        >
          Print Job
        </div>
        {/* <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={printallinspections}
        >
          Print Inspections
        </div> */}
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={scaffoldingInspections}
        >
          Scaffolding Inspections
        </div>

        <div className="border-b border-gray-200 pb-1 mt-4 mb-2">
          <h3 className="px-2 text-sm font-semibold text-gray-1000">Archive</h3>
        </div>

        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={archiveQoute}
        >
          Archive Quote
        </div>

        <div className="border-b border-gray-200 pb-1 mt-4 mb-2">
          <h3 className="px-2 text-sm font-semibold text-gray-1000">
            Vehicles
          </h3>
        </div>

        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={AddANewVechile}
        >
          Add your vehicle
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors"
          onClick={vechicleCheck}
        >
          Vehicle check
        </div>
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors mb-8"
          onClick={vechicleInspection}
        >
          Vehicle inspection
        </div>
        
        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors mb-8"
          onClick={() => window.open("https://features.sdlpro.management/", "_blank")}
        >
          Vehicle Load Calculator
        </div>

        <div
          className="px-3 py-2 rounded-md text-sm hover:bg-[#66c18a] hover:text-white cursor-pointer transition-colors mb-8"
          onClick={signOutt}
        >
          Sign out
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
